const GET_UNIDADES = 'GET_UNIDADES';
const SELECIONAR_UNIDADE = 'SELECIONAR_UNIDADE';
const UNIDADE_NOT_FOUND = 'UNIDADE_NOT_FOUND';
const LOADING_UNIDADE = 'LOADING_UNIDADE';

export { GET_UNIDADES, UNIDADE_NOT_FOUND, SELECIONAR_UNIDADE, LOADING_UNIDADE };